export default "__VITE_ASSET__DLDg6ydU__"